export default __webpack_public_path__ + "static/media/student-avatar-customization.fcec6c5c.png";